import styled from 'styled-components';

const ToggleSwitchStyled = styled.div`
  .toggle-switch {
    display: flex;
    align-items: center;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 28px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${(props) => props?.theme?.color?.borderLight};
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 34px;
    width: 45px;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 28px;
    width: 28px;
    background-color: ${(props) => props?.theme?.color?.white};
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
    border: 1px solid ${(props) => props?.theme?.color?.borderLight};
  }

  input:checked + .slider {
    background-color: ${(props) => props?.theme?.green?.switchgreen};
    border: 1px solid ${(props) => props?.theme?.green?.switchgreen};
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(16px);
    -ms-transform: translateX(16px);
    transform: translateX(16px);
    border: 1px solid ${(props) => props?.theme?.green?.switchgreen};
    bottom: -1px;
  }
`;

export default ToggleSwitchStyled;
